import styled from 'styled-components';
import { layout } from 'src/components/base';
import { OutlinedButton } from '@prisjakt/ui/button/variants';
import { Card, CardContent, CardMedia } from '@prisjakt/ui/card';
import { BodySmallText } from '@prisjakt/ui/text/variants';

export const ArticleCarouselContainer = styled.div`
  margin: ${layout.measurements.spacing050};
`;

export const ReadMoreLink = styled(OutlinedButton)`
  width: 100% !important;

  > span {
    flex-grow: 0;
  }
`;

export const ArticlePreviewCard = styled(Card)`
  max-width: 235px;
  height: 390px;
`;

export const ArticlePreviewCardMedia = styled(CardMedia)`
  min-height: 120px;
`;

export const ArticlePreviewCardContent = styled(CardContent)`
  padding: ${layout.measurements.spacing075} !important;
`;

export const EllipsisSmallText = styled(BodySmallText)`
  flex-grow: 10;
  max-height: 102px;
  text-overflow: ellipsis;
  /* stylelint-disable value-no-vendor-prefix  */
  display: -webkit-box;
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
`;
